import { create } from 'zustand';
import { ApiUtils, RequestStrategyEnum } from '@shared/utils';
import { ContentApi, type TariffJsonResponse } from '@shared/api';

interface TariffStoreType {
  data: TariffJsonResponse | null;
  loading: boolean;
  error: string | null;
  getTariff: (signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useTariffStore = create<TariffStoreType>((set) => ({
  data: null,
  loading: false,
  error: null,

  getTariff: ApiUtils.wrapperApi(async (signal) => {
    try {
      set({ loading: true, error: null, data: null });
      const result = await ContentApi.getTariffJson(signal);
      set({ data: result ?? null, loading: false });
    } catch (error) {
      set({ error: ApiUtils.getApiError(error), loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ data: null, loading: false, error: null }),
}));
